import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import PosterWall from '../components/PosterWall';
import Features from '../components/Features';
import HowItWorks from '../components/HowItWorks';
import CTA from '../components/CTA';
import AppDownloadButton from '../components/AppDownloadButton';
import Footer from '../components/Footer';
import Seo from '../components/Seo';
import { RECRUITER_WHATSAPP_LINK } from '../constants/externalLinks';


const RecruiterLandingPage = () => {
  return (
    <>
      <Seo
        title="Recruiter Portal for Hiring Verified Workers"
        description="Use Jobisa's recruiter portal to post jobs, manage campaigns, and hire verified workers for local and abroad roles."
        path="/recruiter"
        structuredData={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: 'Jobisa Recruiter Portal',
          url: 'https://jobisa.in/recruiter',
          description: 'Recruiter portal for posting jobs and hiring verified workers.',
        }}
      />
      <Navbar isRecruiterSite={true} />
      <main className="flex-grow">
        <Hero />
        <PosterWall />
        <Features />
        <HowItWorks />
        <CTA />
        <section className="max-w-6xl mx-auto px-6 lg:px-12 py-16">
          <div className="max-w-4xl">
            <h2 className="text-3xl font-bold text-slate-900">Hire Verified Workers Faster with Jobisa</h2>
            <p className="mt-4 text-slate-600 leading-8">
              Jobisa helps recruiters and agencies hire verified workers for local and abroad jobs. Create campaigns,
              manage applicants, shortlist workers, schedule interviews, and run your hiring workflow from one portal.
            </p>
            <p className="mt-4 text-slate-600 leading-8">
              Whether you recruit for construction, mechanical, electrical, civil, or industrial roles, Jobisa helps
              you reach skilled workers with a structured mobile-first hiring experience.
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <AppDownloadButton
                href="/download/recruiter"
                className="inline-flex items-center rounded-2xl bg-slate-900 px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-slate-900/15 transition hover:bg-slate-800"
              >
                Download Recruiter App
              </AppDownloadButton>
              <a
                href={RECRUITER_WHATSAPP_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center rounded-2xl border border-emerald-300 bg-emerald-50 px-6 py-3 text-sm font-semibold text-emerald-700 transition hover:border-emerald-400 hover:bg-emerald-100"
              >
                Chat on WhatsApp
              </a>
              <a
                href="/login"
                className="inline-flex items-center rounded-2xl border border-slate-300 px-6 py-3 text-sm font-semibold text-slate-700 transition hover:border-slate-400 hover:text-slate-900"
              >
                Open Recruiter Portal
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default RecruiterLandingPage;
